import React, { Component } from "react";
import TooltipWrapper from "../../shared/items/contols/tooltipWrapper";
import { carsStatuses } from "../sections/cars/static.carsStatuses";
import { remove, concat } from "lodash";
import CarStatusTitle from "../../shared/items/static/carStatusTitle";

import styles from "./statusMarkerControl.module.scss";

class StatusMarkerControl extends Component {
  render() {
    const { statusesArray, setStatus } = this.props;

    return (
      <TooltipWrapper title={"Фильтр маркеров карты"} position={"left"}>
        <div className={styles.statuses_container}>
          {Object.keys(carsStatuses)
            .filter((item) => {
              return item === "loss" || item === "inmotion" || item === "parking";
            })
            .map((key) => {
              return (
                <div
                  className={
                    statusesArray.includes(`${carsStatuses[key].id}`)
                      ? styles.button_status
                      : styles.button_status_disabled
                  }
                  onClick={
                    statusesArray.includes(`${carsStatuses[key].id}`)
                      ? () => {
                          let nextStatuses = statusesArray;
                          remove(nextStatuses, (n) => {
                            return parseInt(n) === carsStatuses[key].id;
                          });
                          setStatus(nextStatuses.join(","));
                        }
                      : () => {
                          let nextStatuses = statusesArray;
                          nextStatuses = concat(nextStatuses, `${carsStatuses[key].id}`);
                          setStatus(nextStatuses.join(","));
                        }
                  }
                  key={carsStatuses[key].id}
                >
                  <CarStatusTitle status={carsStatuses[key].id} />
                </div>
              );
            })}
        </div>
      </TooltipWrapper>
    );
  }
}

export default StatusMarkerControl;
